import {earnings, deductions} from 'models/PayStub/PayStub.configs'
import {getFormattedDate} from 'src/utils'

import defaultValues from './config/templates.defaultValues'

export function getHandledTemplatesData(
	data: docs.IPaystubData | undefined,
	activeItem: number,
	isSeparateCustomDeduction = false,
) {
	const earningsArr: (IEarningsStub | undefined)[] = []
	const deductionsArr: (IDeductionsStub | undefined)[] = []

	earnings.forEach(({key}) => {
		const item = data?.items[activeItem].earnings[key]
		if (item) {
			earningsArr.push(item)
		}
	})

	deductions.forEach(({key}) => {
		const item = data?.items[activeItem].deductions[key]
		if (item) {
			deductionsArr.push(item)
		}
	})

	const earingsData = data
		? [...earningsArr, ...data?.items[activeItem].customEarnings]
		: [...Object.values(defaultValues.items[0].earnings)]

	const customDeductions =
		data?.items[activeItem].customDeductions.filter((item) => item.ytd !== '0.00') || []

	const deductionsData = data
		? [...deductionsArr, ...(isSeparateCustomDeduction ? [] : customDeductions)]
		: [...Object.values(defaultValues.items[0].deductions)]

	const payPeriodFrom =
		getFormattedDate(data?.items[activeItem].payPeriod.from, {
			locales: 'en-US',
			options: {month: '2-digit', day: '2-digit', year: 'numeric'},
		}) || defaultValues.items[0].payPeriod.from

	const payPeriodTo =
		getFormattedDate(data?.items[activeItem].payPeriod.to, {
			locales: 'en-US',
			options: {month: '2-digit', day: '2-digit', year: 'numeric'},
		}) || defaultValues.items[0].payPeriod.to

	const payDate =
		getFormattedDate(data?.items[activeItem].payDate, {
			locales: 'en-US',
			options: {month: '2-digit', day: '2-digit', year: 'numeric'},
		}) || defaultValues.items[0].payDate

	if (isSeparateCustomDeduction) {
		return {earingsData, deductionsData, customDeductions, payPeriodFrom, payPeriodTo, payDate}
	}

	return {earingsData, deductionsData, payPeriodFrom, payPeriodTo, payDate}
}
